import Render from '@Views/components/popin/layout/popin-substitute-rfe.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { user } from '@Store/modules'
import { IStripeSubscription } from '@Store/types'
import { StripeSubscriptionType } from '@Enums/stripe-subscription-type'

interface ISubstituteRfeOptions {
	substituteId: string
	substituteName: string
}

@Render
@Component({})
export class PopinSubstituteRfe extends Vue {
	@Prop({ required: true }) options!: ISubstituteRfeOptions
	@Prop({ default: false }) submitted: boolean
	@Prop({ default: false }) loading: boolean

	readonly RFE_PACK_ANNUAL_PRICE = 57.60
	readonly RFE_PACK_START_DATE = new Date('2026-09-01')

	get substituteName(): string {
		return this.options && this.options.substituteName || ''
	}

	private get subscription(): IStripeSubscription {
		return user.currentUser && user.currentUser.stripeSubscription
	}

	get isAnnualSubscription(): boolean {
		return !!this.subscription && Number(this.subscription.value) === StripeSubscriptionType.year
	}

	private get prorataStartDate(): Date {
		const now = new Date()
		return now < this.RFE_PACK_START_DATE ? this.RFE_PACK_START_DATE : now
	}

	private get rfePackProrataAmount(): number {
		if (!this.subscription || !this.subscription.session_date) return 0

		const endDate = new Date(this.subscription.session_date)
		const msPerDay = 1000 * 60 * 60 * 24
		const remainingDays = Math.max(0, Math.ceil((endDate.getTime() - this.prorataStartDate.getTime()) / msPerDay))

		return (this.RFE_PACK_ANNUAL_PRICE / 365) * remainingDays
	}

	// Montant ajouté à la prochaine facture pour ce remplaçant.
	get nextInvoiceAmount(): number {
		return this.isAnnualSubscription ? this.rfePackProrataAmount : this.RFE_PACK_ANNUAL_PRICE / 12
	}

	// Montant récurrent (par an pour un abonnement annuel, par mois sinon).
	get recurringAmount(): number {
		return this.isAnnualSubscription ? this.RFE_PACK_ANNUAL_PRICE : this.RFE_PACK_ANNUAL_PRICE / 12
	}

	private get subscriptionEndDate(): Date {
		return this.subscription && this.subscription.session_date ? new Date(this.subscription.session_date) : null
	}

	get prorataStartDateShort(): string {
		return this.formatDateShort(this.prorataStartDate)
	}

	get subscriptionEndDateShort(): string {
		return this.subscriptionEndDate ? this.formatDateShort(this.subscriptionEndDate) : ''
	}

	formatAmount(amount: number): string {
		return `${amount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € TTC`
	}

	formatDateShort(date: Date): string {
		return new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		}).format(date)
	}
}
